export default __webpack_public_path__ + "static/media/basketball.e6a21957.png";